import ContactServiceLegacy from '@/bundles/Contact/services/ContactServiceLegacy';
import { httpV1 } from '@/bundles/Http/factory/httpFactory';
import ErrorMapper from '@/bundles/Http/mappers/ErrorMapper';

function contactServiceLegacyFactory () {
  return new ContactServiceLegacy(httpV1, new ErrorMapper());
}

export const contactServiceLegacy = contactServiceLegacyFactory();
